import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetSeamVisionlineDisconnectedUsersRequest = {
  buildingId: number
}

export type SeamVisionlineDisconnectedUser = {
  id: string
  name?: string
  email?: string
}

export const getSeamVisionlineDisconnectedUsersQueryKey = (
  data: GetSeamVisionlineDisconnectedUsersRequest,
) => ['useGetSeamVisionlineDisconnectedUsers', data]

const getSeamVisionlineDisconnectedUsers = async (
  data: GetSeamVisionlineDisconnectedUsersRequest,
) => {
  const response = await authAPI.get<SeamVisionlineDisconnectedUser[]>(
    `/seam-visionline/disconnected-users/${data.buildingId}`,
  )
  return response.data
}

export const useGetSeamVisionlineDisconnectedUsers = (
  data: GetSeamVisionlineDisconnectedUsersRequest,
  enabled = false,
) =>
  useQuery({
    enabled: enabled && Boolean(data.buildingId),
    queryFn: () => getSeamVisionlineDisconnectedUsers(data),
    queryKey: getSeamVisionlineDisconnectedUsersQueryKey(data),
  })
